import FilterOperator from "../Filters/FilterOperator";
import FilterPropertyType from "../Filters/FilterPropertyType";

const filterProperties = [
	{
		name: "State",
		key: "event",
		type: FilterPropertyType.ENUM,
		typeData: {
			options: ["takeoff", "cruising", "descent", "landed"]
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT]
	},
	{
		name: "Flight Number",
		key: "flight",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Operator",
		key: "operator",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Equipment",
		key: "equipment",
		type: FilterPropertyType.STRING, // TODO: enum
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Registration",
		key: "registration",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Altitude",
		key: "altitude",
		type: FilterPropertyType.NUMBER,
		operators: [FilterOperator.GT, FilterOperator.LT]
	},
	{
		name: "Call Sign",
		key: "callsign",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Destination (IATA)",
		key: "destinationIATA",
		type: FilterPropertyType.STRING, // TODO: enum
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Destination (ICAO)",
		key: "destination_icao",
		type: FilterPropertyType.STRING, // TODO: enum
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Origin (IATA)",
		key: "origin_iata",
		type: FilterPropertyType.STRING, // TODO: enum
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Origin (ICAO)",
		key: "origin_icao",
		type: FilterPropertyType.STRING, // TODO: enum
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	}
];
export default filterProperties;
